import { extractDate, extractTime } from '../../utils/dateTimeUtils';
angular.module('leanlaw').controller('EntryEditCtrl', ['$scope', '$state', '$stateParams', '$rootScope', 'leanLawApi', 'entryEditService', 'snippetService', 'matterManager', 'clientManager', 'userService', 'codeService', 'onboardService', 'alerts', 'lists', function ($scope, $state, $stateParams, $rootScope, leanLawApi, entryEditService, snippetService, matterManager, clientManager, userService, codeService, onboardService, alerts, lists) {
  const entrySaveEvent = 'planner-entry-saved';
  $scope.vm = {
    me: undefined,
    matters: [],
    clients: [],
    advancedState: 'Standard',
    client: null,
    matter: null,
    clientOption: {},
    matterOption: {},
    tasks: undefined,
    task: undefined,
    codes: {},
    date: undefined,
    account: {},
    accounts: [],
    saving: false,
    adjustments: false,
    okToClearDescription: false,
    descriptionFocus: false,
    keepTimer: false,
    usingHours: true,
    reload: false,
    rateList: [],
    expanded: true,
    //!!$stateParams.expanded;
    showKeepTimer: $stateParams.timerId,
    lockCalculatingHoursFromDescription: false,
    showDecimalError: false,
    entryBillingTypes: [],
    fixedFeeList: [],
    billingType: {},
    activated: false,
    disableSave: false
  };
  $scope.cmQuery = {
    originating: false,
    involved: false,
    reviewer: false,
    primary: false,
    scopeAccount: $scope.vm.account?.id || null,
    status: '',
    archived: false
  };

  // functions
  $scope.getStep = entryEditService.getStep;
  $scope.getMinuteStep = entryEditService.getMinuteStep;
  $scope.getTaskLabel = snippetService.getTaskLabel;
  activate();
  $scope.taskSelect = function (task) {
    entryEditService.updateDescriptionFromTask($scope.entry, task);
    $scope.vm.task = null;
    $scope.vm.descriptionFocus = true;
  };
  $scope.createMatter = function () {
    const clientId = $scope.entry.client ? $scope.entry.client.clientId : null;
    $state.go('.matter', {
      clientId
    });
  };
  $scope.accountChanged = function () {
    $scope.cmQuery.scopeAccount = $scope.vm.account.id;
    const {
      autoAssign
    } = $scope.vm.me.permissions.matters;
    if (autoAssign || $scope.vm.account && $scope.vm.account.id !== $scope.vm.me.id) {
      // load matters if a different user is selected or we
      // have autoassign switched on
      $scope.cmQuery.involved = !autoAssign;
    }
    adjustRateToSelection(true);
  };
  function round2(n) {
    return Math.round(n * 100) / 100;
  }
  $scope.checkDescription = function (code, activity, task) {
    if (!code) return;
    const codesSettings = $scope.me.company.settings.codes || {};
    let description = '';
    if (codesSettings.populateDescriptionsPlus) {
      // For populateDescriptionsPlus: always check both codes and combine them
      let activityDesc = $scope.entry.codes.activity ? $scope.entry.codes.activity.label : '';
      let taskDesc = $scope.entry.codes.task ? $scope.entry.codes.task.label : '';
      if (activityDesc && taskDesc) {
        description = `${activityDesc}, ${taskDesc}`;
      } else if (activityDesc) {
        description = activityDesc;
      } else if (taskDesc) {
        description = taskDesc;
      }
    } else {
      // For populateDescriptions only: use the most recently selected code
      if (activity && $scope.entry.codes?.activity?.label) {
        description = $scope.entry.codes.activity.label;
      }
      if (task && $scope.entry.codes?.task?.label) {
        description = $scope.entry.codes.task.label;
      }
    }
    if (codesSettings.populateDescriptions && (!$scope.entry.description || $scope.vm.okToClearDescription)) {
      $scope.entry.description = description;
    }
  };
  $scope.matterChanged = function () {
    if ($scope.entry.id) {
      // If we are editing, make sure the billing
      // type is consistent with the matter otherwise
      // flip it
      if ($scope.entry?.billingType === 'fixedFee' && $scope.entry.matter?.billing?.type !== 'fixed') {
        $scope.entry.billingType = 'nonBillable';
      }
      if ($scope.entry?.billingType === 'nonBillable' && $scope.entry.matter?.billing?.type === 'fixed') {
        $scope.entry.billingType = 'fixedFee';
      }
      if ($scope.entry.matter && $scope.entry.matter?.billing?.type === 'contingency') {
        $scope.entry.billingType = 'nonBillable';
      }
      if ($scope.entry.matter && $scope.entry.matter?.billing?.type === 'hours') {
        $scope.entry.billingType = 'billable';
      }
    } else {
      // If it is a new entry, make the billing type
      // the default according to the matter type
      const defaultBillingType = !$scope.entry.matter ? 'billable' : $scope.entry.matter.billing.type == 'fixed' ? 'fixedFee' : $scope.entry.matter.billing.type == 'hours' ? 'billable' : 'nonBillable';
      $scope.entry.billingType = defaultBillingType;
      if ($scope.entry.matter) {
        // This sets the default activity/task code if there is only one of them
        // (will happen if you only have expert code set enabled)
        if ($scope.entry.matter.client.codes && $scope.entry.matter.client.codes.ledes) {
          $scope.entry.codes = $scope.entry.codes || {};
          if ($scope.vm.codes.task.length == 1) {
            $scope.entry.codes.task = $scope.vm.codes.task[0];
          }
          if ($scope.vm.codes.activity.length == 1) {
            $scope.entry.codes.activity = $scope.vm.codes.activity[0];
          }
        }
      }
    }
    adjustRateToSelection(true);
  };
  async function getCharge() {
    await entryEditService.getChargeList($scope.entry.matter, $scope.vm, $scope.entry);
  }

  // note: called by sub-state .matter when creating a new client/matter
  $scope.matterCreated = function (created = {}) {
    $scope.vm.matter = created;
    $scope.entry.matter = created;
    $scope.entry.client = created.client;
    $scope.matterChanged();
  };
  $scope.delete = function () {
    bootbox.confirm('This will permanently delete the time entry. Is that ok?', result => {
      if (result) {
        leanLawApi.deleteEntry({
          id: $scope.entry.id
        }).then(() => {
          // Don't reload if we're saving on the new time planner or if we're saving on the reports page
          const willReload = !$state.includes('timeplanner') && !$state.includes('reports.generic');
          $state.go('^', {}, {
            reload: willReload
          });
        });
      }
    });
  };
  $scope.changeBillableType = function () {
    if (!$scope.vm.billingType) return;
    const {
      id
    } = $scope.vm.billingType;
    $scope.entry.billingType = id;
    if (id === 'fixedFee') {
      getCharge();
    } else {
      $scope.vm.fixedFee = {};
    }
    if (id !== 'nonBillable') {
      entryEditService.adjustRateToCompletionBasedSelection($scope.entry, $scope.vm.account, $scope.vm);
    }
  };
  $scope.$watch('vm.fixedFee.id', () => {
    $scope.changeCharge();
  });
  $scope.$watch('vm.client', (newVal, oldVal) => {
    if (newVal?.id && newVal?.id !== oldVal?.id) {
      if (newVal.id === $scope.entry.matter?.client?.id) {
        $scope.entry.client = $scope.entry.matter.client;
      } else {
        $scope.vm.disableSave = true;
        clientManager.get($scope.vm.client.id).then(client => {
          $scope.entry.client = client;
          if ($scope.vm.matter) {
            $scope.vm.matter.client = client;
          }
          $scope.vm.disableSave = false;
        });
      }
    }
  });
  $scope.$watch('vm.matter', (newVal, oldVal) => {
    if (newVal?.id && newVal?.id !== oldVal?.id && newVal?.id !== $scope.entry.matter?.id) {
      $scope.vm.disableSave = true;
      matterManager.get($scope.vm.matter.id).then(matter => {
        $scope.entry.matter = matter;
        if ($scope.vm.matter) {
          clientManager.get($scope.vm.matter.clientId).then(client => {
            $scope.vm.matter.client = client;
          });
        }
        $scope.matterChanged();
        $scope.vm.disableSave = false;
      });
      $scope.disableSave = false;
    }
  });
  $scope.changeCharge = function () {
    if (!$scope.vm.me) return;
    if (!$scope.vm.fixedFee && $scope.entry && $scope.entry.charge) {
      $scope.entry.charge = {};
      return;
    }
    $scope.entry.charge = $scope.vm.fixedFee;
    $scope.entry.chargeId = $scope.vm.fixedFee.id;
  };
  $scope.changeHours = function () {
    if ($scope.entryForm.hours && $scope.entryForm.hours.$valid) {
      entryEditService.updateEndTime($scope.entry);
    }
    $scope.checkPrecision();
    entryEditService.updateStepFromEntry($scope.entry);
    $scope.vm.usingHours = true;
    $scope.vm.lockCalculatingHoursFromDescription = true;
  };
  $scope.changeStartTime = function () {
    if (!$scope.entry.startTime) return;
    entryEditService.updateEndTime($scope.entry);
  };
  $scope.changeEndTime = function () {
    entryEditService.updateHours($scope.entry);
    $scope.vm.usingHours = false;
  };
  $scope.now = function (date) {
    const now = new Date();
    const nowDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), now.getHours(), now.getMinutes());
    return roundTime(nowDate);
  };
  $scope.changeDate = function () {
    const {
      date
    } = $scope.vm;
    if (date) {
      const time = $scope.entry.startTime;
      $scope.entry.startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes());
      entryEditService.updateEndTime($scope.entry);
    }
  };
  async function adjustRateToSelection(refresh) {
    $scope.$applyAsync(() => {
      $scope.vm.disableSave = true;
    });
    await entryEditService.adjustRateToSelection(refresh, $scope.entry, $scope.vm.account, $scope.vm);
    $scope.$applyAsync(() => {
      $scope.vm.disableSave = false;
    });
  }
  $scope.rateChanged = function () {
    const {
      selectedRate
    } = $scope.vm;
    if (selectedRate) {
      // Rate selected, mark as edited
      $scope.entry.rate = {
        ...selectedRate,
        edited: true
      };
    } else {
      // Rate unselected, revert back to default
      adjustRateToSelection(true);
    }
  };
  $scope.manualRateChanged = function () {
    $scope.vm.selectedRate = null;
    $scope.entry.rate.label = '';
    $scope.entry.rate.edited = true;
  };
  $scope.duplicate = function () {
    const startTime = new Date();
    const endTime = new Date();
    const newEntry = $scope.entry;
    startTime.setHours($scope.entry.startTime.getHours(), $scope.entry.startTime.getMinutes());
    endTime.setHours($scope.entry.endTime.getHours(), $scope.entry.endTime.getMinutes());
    const durationHours = (endTime - startTime) / 1000 / 60 / 60;
    const {
      account,
      client,
      matter,
      description,
      rate,
      billingType,
      codes,
      chargeId
    } = newEntry;
    $state.go('timeplanner.new', {
      entry: {
        account,
        startTime,
        originalEntry: $scope.entry,
        client,
        matter,
        hours: +durationHours,
        description,
        rate: {
          ...rate,
          edited: rate?.edited || false
        },
        copyBillingType: billingType,
        copyChargeId: chargeId,
        codes,
        duplicate: true
      }
    });
  };
  $scope.save = function () {
    $scope.changeDate();
    if ($scope.entryForm.$invalid) {
      return;
    }
    if ($scope.entry.hours <= 0) {
      $scope.entryForm.$setPristine();
      alerts.error('Hours must be greater than zero');
      return;
    }
    if ($scope.entry.rate?.amount < 0) {
      $scope.entryForm.$setPristine();
      alerts.error('Amount cannot be negative');
      return;
    }

    // Check for billable entry with $0 rate
    if ($scope.entry.billingType === 'billable' && $scope.entry.rate?.amount === 0) {
      bootbox.confirm('This entry is marked as billable but has a $0.00 rate. Do you want to continue saving?', result => {
        if (result) {
          performSave();
        }
      });
      return;
    }
    performSave();
  };
  function performSave() {
    const entry = angular.copy($scope.entry);
    if (entry.account || $scope.vm.account.id != $scope.vm.me.id) {
      // Set account if we have changed it or if it is new and it's not me
      entry.account = {
        id: $scope.vm.account.id
      };
    }
    if (!$scope.entry.client?.codes?.ledes && $scope.vm.me.company.settings?.codes?.ledes) {
      entry.codes = {};
    }
    entry.matter = {
      id: $scope.vm.matter.id
    }; // trims payload

    entry.matterId = entry.matter?.id;
    if ($scope.vm.adjustments) {
      entry.billedHours = entry.hours - entry.writedown;
      if (entry.billedHours < 0 || entry.writedown < 0) {
        alerts.error('Write-down cannot be negative or exceed the worked hours');
        return;
      }
    } else {
      entry.billedHours = entry.hours;
    }
    if (entry.charge) {
      entry.chargeId = entry.charge.id;
      entry.charge = undefined;
    }
    // NEW: Send localDateTime format for backend (Story #25310)
    // Backend will handle timezone conversion using user's timezone setting
    // TODO (Story #25310): Remove legacy startTime/endTime after migration complete
    if ($scope.vm.date && entry.startTime) {
      entry.localDateTime = {
        date: extractDate($scope.vm.date),
        time: extractTime(entry.startTime)
      };
    }
    const api = entry.id ? leanLawApi.updateEntry({
      id: entry.id,
      body: entry
    }) : leanLawApi.createEntry({
      body: {
        ...entry,
        client: undefined // we sometimes get a client object so clear it out
      }
    });
    $scope.vm.saving = true;
    api.then(updated => {
      if ($scope.vm.reload) {
        $scope.reload();
        return $state.go('^');
      }
      // Broadcast message (and clear timer if set)
      entry.client = $scope.vm.client;
      $rootScope.$broadcast(entrySaveEvent, $stateParams.timerId, entry, $scope.vm.keepTimer);
      onboardService.reload();
      // Don't reload if we're saving on the new time planner or if we're saving on the reports page
      const willReload = !$state.includes('timeplanner') && !$state.includes('reports.generic');
      $state.go('^', {}, {
        reload: willReload
      });
    }).catch(err => {
      alerts.error(err);
      $scope.entryForm.$setPristine(true);
      $scope.vm.saving = false;
    });
  }

  /////////////////////////////////

  async function activate() {
    const me = await userService.me();
    $scope.vm.me = me;
    const {
      autoAssign
    } = me.permissions.matters;
    $scope.cmQuery.involved = !autoAssign;
    if (me.settings?.enableNewTimeEntry && me.features?.timeEntriesTab) {
      const {
        name
      } = $state.current;
      const replacementPatterns = [{
        key: 'new',
        replacement: 'new2'
      }, {
        key: 'edit',
        replacement: 'edit2'
      }, {
        key: 'entry',
        replacement: 'entry2'
      }, {
        key: 'time',
        replacement: 'time2'
      }];
      for (let pattern of replacementPatterns) {
        if (name.includes(pattern.key)) {
          const newState = name.replace(pattern.key, pattern.replacement);
          if ($stateParams.entryId) {
            $state.go(newState, {
              entryId: $stateParams.entryId
            });
          } else if ($stateParams.timerId) {
            $state.go(newState, {
              entry: $stateParams.entry,
              expanded: $stateParams.expanded,
              timerId: $stateParams.timerId
            });
          } else {
            $state.go(newState, {
              entry: $stateParams.entry
            });
          }
          return;
        }
      }
    }
    entryEditService.resetStep();
    codeService.activityCodes().then(activity => {
      $scope.vm.codes.activity = activity;
    });
    codeService.taskCodes().then(task => {
      $scope.vm.codes.task = task;
    });
    $scope.allowAddingClientMatter = !$stateParams.entryId || $stateParams.allowAddingClientMatter;
    $scope.vm.accounts = await userService.list();
    leanLawApi.listTasks().then(list => {
      $scope.vm.tasks = list.tasks;
      snippetService.addShortCodeHandler('timeentry-description', $scope.vm.tasks);
    });
    $scope.vm.entryBillingTypes = lists.entryBillingTypes;
    if (!$scope.vm.account) {
      $scope.vm.account = $scope.vm.me;
      $scope.cmQuery.scopeAccount = $scope.vm.me.id;
    }
    $scope.vm.rateList = me.rateList;
    if ($stateParams.entryId) {
      // editing existing entry, get it
      leanLawApi.getEntry({
        id: $stateParams.entryId
      }).then(async entry => {
        $scope.entry = entry;
        $scope.vm.originalDescription = entry.description;
        $scope.vm.originalHours = entry.hours;
        if (me.adjustments) {
          let {
            hours,
            billedHours
          } = entry;
          billedHours = billedHours === undefined ? hours : billedHours;
          $scope.vm.adjustments = $stateParams.adjustments || hours > billedHours;
          if ($scope.vm.adjustments) {
            $scope.entry.writedown = round2(hours - billedHours);
          }
        }
        entryEditService.updateStep(entry.hours);
        $scope.vm.date = new Date($scope.entry.startTime);
        $scope.entry.startTime = new Date($scope.entry.startTime);
        entryEditService.updateEndTime($scope.entry);
        $scope.vm.account = entry.account;
        const {
          id,
          role
        } = $scope.entry.account;
        const user = $scope.vm.accounts.find(u => u.id === id);

        // Filter only valid accounts, skipping the 'disabled' and 'accountant' role accounts.
        $scope.vm.accounts = $scope.vm.accounts.filter(u => u.role !== 'accountant');

        // If the current user is 'disabled' or has the role of 'accountant' and is not in the list, add them back.
        if (role === 'accountant') {
          if (!$scope.vm.accounts.find(a => a.id === id)) {
            $scope.vm.accounts.push(user);
          }
        }
        $scope.vm.billingType.id = $scope.entry.billingType;
        if ($scope.vm.billingType.id === 'fixedFee') {
          await getCharge();
          $scope.vm.fixedFee = $scope.vm.fixedFeeList.find(charge => charge?.id === $scope.entry?.chargeId);
        }
        $scope.vm.client = {
          id: $scope.entry.matter?.client?.id
        };
        $scope.vm.matter = {
          id: $scope.entry.matter?.id
        };
        adjustRateToSelection(false);
        $scope.vm.activated = true;
      });
    } else {
      // creating new entry, set defaults or use what was passed in
      $scope.entry = newDefaultEntry($stateParams.entry, $stateParams.item);
      $scope.vm.okToClearDescription = !$scope.entry.description;
      $scope.vm.date = new Date($scope.entry.startTime);
      entryEditService.updateEndTime($scope.entry);
      $scope.vm.account = $scope.entry.account || $scope.vm.me;
      if ($scope.vm.account && $scope.vm.account.id != $scope.vm.me.id) {
        $scope.vm.expanded = true;
      }
      $scope.vm.accounts = $scope.vm.accounts.filter(user => user.role !== 'accountant');
      adjustRateToSelection(false);
      $scope.vm.activated = true;
    }
  }
  function newDefaultEntry(init, item) {
    const entry = angular.copy(init) || {};
    entry.source = 'myleanlaw';
    entry.startTime = roundedTime(entry.startTime || new Date());
    if (item) {
      entry.item = item;
    }
    if (entry.matter) {
      var clientId = entry.matter.clientId || entry.matter.client?.id;
      matterManager.get(entry.matter.id).then(m => {
        entry.matter = m;
        // Delegate billing type defaulting, duplicate restoration, and
        // charge/rate loading to the centralised service logic.
        adjustRateToSelection(true);
      });
      $scope.vm.matter = {
        id: entry.matter.id
      };
      if (clientId) {
        clientManager.get(clientId).then(c => {
          entry.client = c;
        });
        $scope.vm.client = {
          id: clientId
        };
      }
    } else if (entry.client) {
      clientManager.get(entry.client.id).then(c => {
        entry.client = c;
      });
      $scope.vm.client = {
        id: entry.client.id
      };
    }
    entry.description = entry.description || '';
    entry.hours = entry.hours || 0.1;
    $scope.vm.showTracked = false;
    entry.billingType = entry.billingType || 'billable';
    return entry;
  }
  function roundedTime(t) {
    t = new Date(t); // make sure it is a date object

    let minutes = t.getMinutes();
    if (minutes === 0 || minutes === 30) {
      entryEditService.updateStep(0.5);
    } else if (minutes === 15 || minutes === 45) {
      entryEditService.updateStep(0.25);
    } else if (minutes % 10 === 0) {
      entryEditService.updateStep(0.1);
    } else {
      $scope.vm.me?.company?.settings?.timeEntryIncrement == '0.1' ? entryEditService.updateStep(0.1) : entryEditService.updateStep(0.01);
      t.setMinutes(Math.floor(t.getMinutes() / 6) * 6);
    }
    t.setSeconds(0);
    return t;
  }
  function roundTime(t) {
    if (t.getMinutes() != 15 || t.getMinutes() != 45) {
      t.setMinutes(Math.floor(t.getMinutes() / 6) * 6);
    }
    t.setSeconds(0);
    return t;
  }
  $scope.checkPrecision = function () {
    const {
      hours
    } = $scope.entry;
    $scope.vm.showDecimalError = parseFloat(hours) !== parseFloat(hours?.toFixed(2));
  };
  $scope.descriptionChanged = function () {
    $scope.vm.okToClearDescription = false;
    $scope.entry.hours = entryEditService.descriptionHours($scope.entry, $scope.vm) || $scope.entry.hours;
  };
}]);